import { DashboardWidgetType, DashboardWidgetUnion } from '../types';

import { v4 as new_id } from 'uuid';

export const createDashboardWidget = (
  defaults?: Partial<DashboardWidgetUnion>
): DashboardWidgetUnion => {
  return {
    id: new_id(),
    type: defaults?.type || DashboardWidgetType.NEXT_EVENT,
    positions: {
      ...defaults?.positions,
    },
  };
};
